  <!-- CREATE EVENT -->
  <div class="card-container">

    <mat-form-field appearance="outline" color="accent">
      <mat-label>
        Instagram URL
      </mat-label>
      <input type="text" #url matInput (keyup)="urlValid = !!url.value">
    </mat-form-field>
    <button mat-raised-button color="primary" [disabled]="!urlValid" (click)="loadFromURL(url.value)">
      Cargar evento desde URL
    </button> 
    <div style="display: flex; flex-flow: column; margin: 20px 0;">
      <mat-slide-toggle (change)="markAsRecurrent($event)">Es un evento recurrente</mat-slide-toggle>

      <div *ngIf="isRecurringEvent" style="display: flex; flex-flow: column;">
          <mat-checkbox (change)="checkDay(index, $event)" [checked]="recurrentDays.indexOf(day) !== -1" 
          *ngFor="let day of days; let index= index;">
              {{
                  day
              }}
          </mat-checkbox>
      </div>
  </div>
    
    <form *ngIf="createForm" [formGroup]="createForm" class="mat-form">

    <div class="row items-center w-100">
      <mat-checkbox formControlName="availableReservation"
     
      >Reservas habilitadas</mat-checkbox>
      <mat-checkbox formControlName="isOffer"  class="mh2">Promoción</mat-checkbox>
    </div>


    <mat-form-field appearance="outline" color="accent" >
      <mat-label>
        Categorías
      </mat-label>
        <mat-select [disabled]="this.dataService?.categories?.length === 0" multiple="" formControlName="categories">
        <mat-option *ngFor="let category of dataService?.categories" [value]="category.categoryId">
            {{category.name}}
        </mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field appearance="outline" color="accent" >
      <mat-label>
        Fecha de inicio
      </mat-label>
        <input matInput [matDatepicker]="picker"  placeholder="17/08/2023"  formControlName="startDateOfEvent">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field appearance="outline" color="accent" >
      <mat-label>
        Fecha de culminación
      </mat-label>
      <input matInput [matDatepicker]="picker2" placeholder="24/08/2023" formControlName="dueDateOfEvent">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field color="accent" appearance="outline"  >
      <mat-label>Precio</mat-label>
      <mat-select formControlName="priceRange" >
        <mat-option value="cheap">0$-20$</mat-option>
        <mat-option value="middle">21$-40$</mat-option>
        <mat-option value="expensive">41$-1000$</mat-option>
      </mat-select>
    </mat-form-field>
    
    <mat-form-field appearance="outline" color="accent" class="form-group">
      <mat-label>Titulo</mat-label>
      <input type="text" matInput  placeholder="Cusica Fest" formControlName="fullName" />
    </mat-form-field>
    <!-- <button (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">😀</button>
          <br /><emoji-mart
          class="emoji-mart"
          *ngIf="isEmojiPickerVisible"
          (emojiSelect)="addEmojiToTitle($event)"
          title="Choose your emoji"
          ></emoji-mart> -->
    

    
      <mat-form-field appearance="outline" color="accent" class="form-group">
        <mat-label>Descripción</mat-label>
        <textarea matInput name="" id="" cols="30" 
        placeholder="Ven a compartir con todos tus amigos! No te pierdas la experiencia!"
        rows="10" formControlName="description" >

        </textarea>
      </mat-form-field>
      <!-- <button (click)="isEmojiPickerDescrVisible = !isEmojiPickerDescrVisible;">😀</button>
      <br /><emoji-mart
      class="emoji-mart"
      *ngIf="isEmojiPickerVisible"
      (emojiSelect)="addEmojiToDescription($event)"
      title="Choose your emoji"
      ></emoji-mart> -->
      
      <mat-form-field appearance="outline" color="accent" class="form-group">
        <mat-label>Link de google maps</mat-label>
        <input type="text" matInput placeholder="https://maps.cr4.fre-er" formControlName="locationName" />
        <mat-error >
          El link debe ser google maps con la forma https://maps....
        </mat-error>
      </mat-form-field>

      <input style="visibility: hidden; height: 0px; width: 0;" type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
      <div class="page-form-image" style="display: flex; flex-flow: column; align-items: center; justify-content: center;" *ngIf="imageUrl">
          <img #imageEvent id="imageEvent" class="event-image"  [src]="imageUrl" alt="">
          <br>
          <button mat-icon-button (click)="deleteImage()">
              <mat-icon appearance="outline" color="accent" >delete_outline</mat-icon>
          </button>
          <br>
      </div>
          
      <div *ngIf="!imageUrl" style="text-align: center; margin-bottom: 24px;">
          <button style="border: 2px dotted; padding: 45px 25px;" (click)="selectFile(fileInput)" mat-button appearance="outline" color="accent" >
          <mat-icon>file_upload</mat-icon>
                  Cargar imagen
          </button>
      </div>
     
      <div class="row w-100" *ngIf="this.dataService.monthNotifications > 0">
        <mat-checkbox class="checkbox" (change)="checkToSendNotification($event.checked)" [checked]="sendNotification">
          Mandar notificacion al {{state ===  'create' ? 'crear': 'editar'}} este evento
        </mat-checkbox>
  
  
        <!-- <div *ngIf="sendNotification && createForm?.controls?.fullName?.value"> -->
        <div *ngIf="sendNotification" class="notification-preview">
          <img src="assets/logo.png" alt="logo of safaera">
          <div>
            <h5>
              {{authService?.userData?.displayName}}
            </h5>
            <p>
              {{createForm?.controls?.fullName?.value}}
            </p>
          </div>
        </div>
      </div>
  
      <div class="row w-100 justify-center items-center">
        <button type="submit" [disabled]="!createForm?.valid" *ngIf="state=== 'create' || state === 'edit'" (click)="saveEventChanges()" mat-raised-button color="primary">{{ state === 'create' ? 'Publicar': 'Editar'}}</button>
      </div>
    </form>

    <div class="loading-cdk" *ngIf="loading">
        <mat-spinner color="accent" diameter="40"></mat-spinner>
    </div>

  </div>